import React from 'react';

import { useNavigate } from 'react-router-dom';
import './SignUpPage.css'; // Import the CSS file

const SignUpPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="signup-page-container">
      <header className="signup-header">
        <button type="button" className="back-arrow-button" onClick={() => navigate('/')} aria-label="Go back to homepage">
          <i className="fas fa-arrow-left"></i>
        </button>
        <div className="logo">
          <i className="fas fa-code"></i> Ocody
        </div>
        <h1>Create Your Account</h1>
      </header>

      <div className="signup-form-container">
        <button onClick={() => navigate('/handler/sign-up')} className="signup-button">
          Sign Up
        </button>
        <p className="signin-prompt">
          Already have an account? <button onClick={() => navigate('/signin')} className="link-button">Sign In</button>
        </p>
      </div>
    </div>
  );
};

export default SignUpPage;
